module.exports = __webpack_public_path__ + "pm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pm.svg
// module id = 762
// module chunks = 0